import { Box } from '@mui/system';
import React, { useCallback, useEffect, useState } from 'react';
import { Map } from 'ol';
import { JGAMap } from '../libs/Map';
import cn from 'classnames';

type Props = {
  jgaMap: JGAMap;
  printHandler?: any;
};

const MapTools = ({ jgaMap, printHandler }: Props) => {
  const [type, setType] = useState('base');
  const [measure, setMeasure] = useState({ length: false, area: false });

  useEffect(() => {
    if (!jgaMap) return;
    window.addEventListener('keydown', (ev) => {
      if (ev.keyCode === 27) {
        console.log('ESC Press');
        setMeasure((prev) => ({ ...prev, length: false, area: false }));
        jgaMap.turnLengthMeasure(false);
        jgaMap.turnAreaMeasure(false);
        ev.preventDefault();
      }
    });
    window.addEventListener('contextmenu', (ev) => {
      ev.preventDefault();
      console.log('right clicked');
      setMeasure((prev) => ({ ...prev, length: false, area: false }));
      jgaMap.turnLengthMeasure(false);
      jgaMap.turnAreaMeasure(false);
    });
  }, [jgaMap]);

  const setMap = useCallback(
    (inputType: 'base' | 'satellite') => {
      if (inputType === 'base') {
        if (type === 'base') return;
        jgaMap.setMapType('base', true);
      } else {
        if (type === 'satellite') return;
        jgaMap.setMapType('satellite', true);
      }
      setType(inputType);
    },
    [type, jgaMap],
  );

  const zoomIn = () => {
    jgaMap.setZoomIn();
  };

  const zoomOut = () => {
    jgaMap.setZoomOut();
  };

  const turnLengthHandler = useCallback(() => {
    if (!jgaMap) return;
    setMeasure((prev) => ({ ...prev, length: !prev.length }));
    jgaMap.turnLengthMeasure(!measure.length);
  }, [measure.length, jgaMap]);

  const turnAreaHandler = useCallback(() => {
    if (!jgaMap) return;
    setMeasure((prev) => ({ ...prev, area: !prev.area }));
    jgaMap.turnAreaMeasure(!measure.length);
  }, [measure.length, jgaMap]);

  return (
    <Box className="mapBtnArea">
      <ul className="mapBtnTypeList">
        <li
          className={cn('mapCommonType', { on: type === 'base' })}
          onClick={() => setMap('base')}
        >
          <div className="mapBtnTypeImg"></div>
          <div className="mapBtnTypeTxt">일반지도</div>
        </li>
        <li
          className={cn('mapSatelliteType', { on: type === 'satellite' })}
          onClick={() => setMap('satellite')}
        >
          <div className="mapBtnTypeImg"></div>
          <div className="mapBtnTypeTxt">위성지도</div>
        </li>
      </ul>
      {/* <!-- mapBtnZoomList : 지도 확대/축소 설정 --> */}
      <ul className="mapBtnZoomList">
        {/* <!-- mapZoomIn : 지도 확대 --> */}
        <li
          className="mapZoomIn"
          onClick={zoomIn}
        ></li>
        {/* <!-- mapZoomOut : 지도 축소 --> */}
        <li
          className="mapZoomOut"
          onClick={zoomOut}
        ></li>
      </ul>

      {/* <!-- mapBtnFuncList : 지도 기능 설정 --> */}
      <ul className="mapBtnFunList">
        {/* <!-- mapDistance : 거리재기 --> */}
        <li
          className="mapDistance"
          onClick={turnLengthHandler}
        ></li>
        {/* <!-- mapExtent : 면적재기 --> */}
        <li
          className="mapExtent"
          onClick={turnAreaHandler}
        ></li>
        {/* <!-- mapPrint : 인쇄 --> */}
        {/* <li
          className="mapPrint"
          onClick={printHandler}
        ></li> */}
      </ul>
    </Box>
  );
};

export default MapTools;
